import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotificationModal = ({ open, onClose, onCardClick, notifications, loading }) => {
    if (!open) return null;
    return (
        <div
            id="notification-modal"
            className="fixed top-[10.6vh] right-[1.65vw] z-50"
            style={{
                width: '28vw',
                maxWidth: 400,
                maxHeight: '50vh',
                background: '#fff',
                borderRadius: '18px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                border: '1px solid #e5e7eb',
                paddingBottom: 8,
            }}
        >
            <div className="flex items-center justify-between p-2 border-b">
                <span className="font-bold text-mainColor pl-1 text-lg">Notifications</span>
                <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-mainColor text-2xl font-bold focus:outline-none"
                >
                    &times;
                </button>
            </div>
            <div className="px-2 py-2">
                {!loading ? (
                    notifications.length === 0 ? (
                        <div className="p-4 text-gray-500 text-center">No New Notifications</div>
                    ) : (
                        notifications.map((notif) => (
                            <div
                                key={notif.id}
                                className="mb-2 last:mb-0 bg-gray-50 rounded-lg shadow-lg p-2 cursor-pointer hover:bg-mainColor/10 transition flex flex-col gap-1"
                                onClick={() => onCardClick(notif)}
                                style={{ border: '1px solid #ececec' }}
                            >
                                <div
                                    className="font-bold text-mainColor text-md"
                                    style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '100%',
                                    }}
                                    title={notif.title}
                                >
                                    {notif.title}
                                </div>
                                <div
                                    className="text-gray-700 text-sm"
                                    style={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxHeight: '2.8em',
                                        lineHeight: '1.6em',
                                    }}
                                    title={notif.message}
                                >
                                    {notif.message}
                                </div>
                                <div className="flex justify-between items-center pt-2 text-xs text-gray-500">
                                    <span>
                                        {notif.created_at && (
                                            new Date(notif.created_at).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                            })
                                        )}
                                    </span>
                                    <span>
                                        {notif.created_at && (
                                            new Date(notif.created_at).toLocaleTimeString('en-US', {
                                                hour: 'numeric',
                                                minute: '2-digit',
                                                hour12: true,
                                            })
                                        )}
                                    </span>
                                </div>
                            </div>
                        ))
                    )) : (
                    <div className="flex items-center justify-center h-32">
                        <CircularProgress size={24} style={{ color: '#6b46c1' }} />
                    </div>
                )}
            </div>
        </div>
    );
};

// const NotificationDetailModal = ({ open, notification, onClose }) => {
//         if (!open || !notification) return null;
//         const dateStr = notification.created_at
//             ? new Date(notification.created_at).toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: 'long',
//                 day: 'numeric',
//             })
//             : '';
//         const timeStr = notification.created_at
//             ? new Date(notification.created_at).toLocaleTimeString('en-US', {
//                 hour: 'numeric',
//                 minute: '2-digit',
//                 hour12: true,
//             })
//             : '';

//         return (
//             <div id="notification-detail-modal" className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//                 <div
//                     className="bg-white rounded-lg shadow-2xl p-4 w-[95vw] max-w-xl flex flex-col"
//                     style={{ minWidth: 340, maxHeight: '80vh', overflowY: 'auto', scrollbarWidth: 'none' }}
//                 >
//                     <div className="flex justify-between items-center mb-3">
//                         <h2 className="text-xl font-bold text-mainColor">Notification Details</h2>
//                         <button onClick={onClose} className="text-gray-500 hover:text-mainColor text-3xl font-bold">&times;</button>
//                     </div>
//                     <div className="mb-2 font-bold text-gray-500 text-lg break-words">{notification.title}</div>
//                     <div className="text-gray-800 text-base leading-relaxed break-words whitespace-pre-line mb-4">
//                         {notification.message}
//                     </div>
//                     <div className="flex justify-between items-center pt-2 text-sm text-gray-500">
//                         <span>
//                             {dateStr}
//                         </span>
//                         <span>
//                             {timeStr}
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         );

//     //adding Navigation to the notification detail modal
//     const navigate = useNavigate();
//     console.log(notification);
//     const type = JSON.parse(localStorage.getItem('userInfo'))?.organization.type;
//     if (type === 'DSO') {
//         if (notification?.title === 'New Display Added') {
//             navigate('/displays');
//         }

//     }
// };

const NotificationDetailModal = ({ open, notification, onClose }) => {
    const navigate = useNavigate();
    const currentRoute = window.location.pathname;

    useEffect(() => {
        if (!open || !notification) return;
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo?.organization?.type !== 'DSO' && userInfo?.organization?.type !== 'ADV') return;

        const type = userInfo?.organization?.type;
        if(notification?.title === 'Display Access Requested') navigate('/advertiser');
        if (notification?.title === 'New Display Added' || notification?.title === 'Displays Affected by Rate Schedule Deletion') {
            if (currentRoute !== '/displays') navigate('/displays');
        } else if (
            notification?.newTitle === 'Added a New Comment' ||
            notification?.newTitle === 'Replied to a Comment' || 
            notification?.newTitle === 'New Campaign Added' ||
            notification?.newTitle === 'Campaign Request Approved' ||
            notification?.newTitle === 'Campaign Request Rejected' ||
            notification?.newTitle === 'Replied to Your Comment' ||
            notification?.newTitle === 'Proof of Play Requested' ||
            notification?.newTitle === 'Proof of Play Uploaded'
        ) {
            if (type === 'DSO' && currentRoute !== '/campaigns-approval') {
                navigate('/campaigns-approval');
            }
            if (type === 'ADV' && currentRoute !== '/campaigns') {
                navigate('/campaigns');
            }
        }
        onClose();
    }, [open, notification, navigate, onClose, currentRoute]);

    return null;
};
const AppNotifications = ({ bellRef, open, setOpen, notifications }) => {
    const [detail, setDetail] = useState(null);

    useEffect(() => {
        const handleClick = (e) => {
            if (!bellRef?.current) return;
            if (
                !bellRef.current.contains(e.target) &&
                !document.getElementById('notification-modal')?.contains(e.target) &&
                !document.getElementById('notification-detail-modal')
            ) {
                setOpen(false);
            }
        };
        if (open) document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [open, bellRef, setOpen, detail]);
    return (
        <>
            <NotificationModal
                open={open}
                onClose={() => setOpen(false)}
                onCardClick={(notif) => setDetail(notif)}
                notifications={notifications}
            />
            <NotificationDetailModal
                open={!!detail}
                notification={detail}
                onClose={() => setOpen(false)}

            />
        </>
    );
};

export default AppNotifications;